import React, { useEffect, useState } from 'react';
import moment from 'moment';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import './table.css';
import 'moment/locale/pt-br';
import AddIcon from '@material-ui/icons/Add';

function AnalistasDisponiveis({ tableData, adicionarAnalistas, disabled }) {
  const bodyTable = tableData?.map(function (item, index) {
    const itemClass = index % 2 === 0 ? 'linha-cinza' : '';
    return (
      <>
        <TableRow className={itemClass}>
        <TableCell style={{ cursor: (disabled ? '' : 'pointer') }} colSpan={2} align="center"
        onClick={() => {
          if(!disabled) {
            adicionarAnalistas(item)
          }}}><AddIcon style={{ fontSize: '15px' }} /></TableCell>
          <TableCell colSpan={8} align="left" style={{ paddingLeft: '10px' }}>
            <span>{item.analista}</span>
          </TableCell>
        </TableRow>
      </>
    );
  });

  return (
        <div
          className="report-tables"
          style={{ justifyContent: 'center' }}
        >
          <Table
            style={{
              backgroundColor: 'white',
              tableLayout: 'fixed',
              boxShadow:
                '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
            }}
            striped
            hover
            condensed
          >
            <TableHead style={{ backgroundColor: '#232C63', color: 'white' }}>
              <TableRow>
                <TableCell
                colSpan={10}
                  align="center"
                  style={{ color: 'white', fontWeight: 'bold' }}
                >
                  Analistas Disponíveis
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bodyTable}
            </TableBody>
          </Table>
        </div>
  );
}

export default AnalistasDisponiveis;
